const minifiedHeader = (options) => {
  const {
    headerDiv,
    minClass,
  } = options;
  let isAccessibleHeader = false;
  const headerContentDiv = document.querySelector('.header-main-section');
  const headerWrapperDiv = document.querySelector('.header-wrapper');
  let topOffset = headerContentDiv.offsetTop;
  // Default offset is <main>, unless there is an active promo
  // in which case apply offset to .promo-bar
  let addOffsetDiv = document.querySelector('main');
  const promoBar = document.querySelector('.promo-bar');
  if (promoBar) {
    addOffsetDiv = promoBar;
  }
  // Fix header, apply offset
  headerDiv.classList.add(minClass);

  const setHeaderOffset = () => {
    if (isAccessibleHeader) {
      return;
    }
    topOffset = headerContentDiv.offsetTop;
    addOffsetDiv.style.marginTop = `${headerContentDiv.offsetHeight + topOffset}px`;
  };

  const enableAccessibleHeader = () => {
    // Check to see if dropdown is open and add to header height
    const activeSubnav = document.querySelector('.subnav.is-active');
    let height = headerContentDiv.offsetHeight;
    if (activeSubnav) {
      const subnav = activeSubnav.querySelector('.dd-nav-wrap');
      height += subnav.offsetHeight;
    }
    if (height > window.innerHeight) {
      isAccessibleHeader = true;
      headerDiv.classList.remove(minClass);
      addOffsetDiv.removeAttribute('style');
    }
  };

  const onResize = () => {
    setHeaderOffset();
  };

  const onScroll = () => {
    if (topOffset <= window.pageYOffset) {
      headerWrapperDiv.style.transform = `translateY(-${topOffset}px)`;
    } else {
      headerWrapperDiv.removeAttribute('style');
    }
    setHeaderOffset();
    enableAccessibleHeader();
  };

  window.addEventListener('scroll', onScroll);
  window.addEventListener('resize', onResize);
  setHeaderOffset();
  enableAccessibleHeader();
};

export default minifiedHeader;
